import { inject, Injectable } from '@angular/core';
import { Microsoft360View } from '../../models/generated/ziroModels';
import { PollingAbstractService } from '../abstract/polling.abstract.service';
import { catchError } from 'rxjs/operators';
import { Microsoft360ViewResource } from '../../resources/microsoft-360-view.resource';
import { Observable } from 'rxjs';

@Injectable()
export class Microsoft360ViewPollingService extends PollingAbstractService<Microsoft360View> {
  private _microsoft360ViewResource = inject(Microsoft360ViewResource);

  static MAX_POLLS = 20;

  baseUrl = '';
  state$: Observable<Microsoft360View> = this._stateSource.pipe(
    catchError((err) => {
      return this._microsoft360ViewResource.handleSecurityGroupLicensingError(err, this._upn);
    }),
  );

  protected _pollingTimeInMilliseconds = 15000;

  private _upn: string;

  setBaseUrl(upn: string, tenantId: string): void {
    this._upn = upn;
    this.baseUrl = `/services/microsoft/views/tenants/${tenantId}/360-view/${upn}`;
  }
}
